import { render, staticRenderFns } from "./org_dialog.vue?vue&type=template&id=6b81607e&scoped=true"
import script from "./org_dialog.vue?vue&type=script&lang=js"
export * from "./org_dialog.vue?vue&type=script&lang=js"
import style0 from "./org_dialog.vue?vue&type=style&index=0&id=6b81607e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81607e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b81607e')) {
      api.createRecord('6b81607e', component.options)
    } else {
      api.reload('6b81607e', component.options)
    }
    module.hot.accept("./org_dialog.vue?vue&type=template&id=6b81607e&scoped=true", function () {
      api.rerender('6b81607e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/program_manage/form/components/org_dialog.vue"
export default component.exports